module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Add a single User or multiple")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.userOptions), function(element) {
    return _c('router-link', {
      staticClass: "list-group-item device",
      attrs: {
        "to": '/admin/user/create/' + element.url
      }
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('p', {
      staticStyle: {
        "font-size": "25px"
      }
    }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(element.description))])])
  }), 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6867f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Users/CreateUser.vue
// module id = 651
// module chunks = 1